import { Url } from '@wix/da-url';
import { getDeviationType, getDeviationUrl } from '../DeviationViews/_helpers';
import { DeviationTypes } from '../types/deviation';
import MediaService from '../utils/DeviationMediaService';
export function getDeviationShareCodes(deviation) {
    var preview = MediaService.getDeviationFile(deviation, 'preview');
    var embedCode = (deviation.extended &&
        deviation.extended.isEmbeddable &&
        deviation.extended.embedCode) ||
        undefined;
    return {
        url: getDeviationShortUrl(deviation),
        media: preview && preview.src,
        thumbCode: ":thumb" + deviation.deviationId + ":",
        embedCode: embedCode,
    };
}
export function getDeviationShortUrl(deviation) {
    // polls, statuses, and commissions are not supported by fav.me
    if ([
        DeviationTypes.STATUS,
        DeviationTypes.COMMISSION,
        DeviationTypes.POLL,
    ].includes(getDeviationType(deviation))) {
        return getDeviationUrl(deviation, true);
    }
    return Url.deviationShortLink(deviation.deviationId);
}
//# sourceMappingURL=helpers.js.map